//document.getElementById('app').innerText = 'hi';
//const {log} = require('../helper');
import cytoscape from 'cytoscape';
import fcose from 'cytoscape-fcose';
import cyUtils from 'cytoscape-layout-utilities';
import eigenRank from './eigenRank';
import louvain from './louvain'
//import eigenRank2 from './eigenRankOrig';
cytoscape.use(eigenRank);
cytoscape.use(louvain);
cytoscape.use(fcose);
cytoscape.use(cyUtils);
//cytoscape.use(eigenRank2);
var nextID = 0;
var relType = 'w';
var cy = cytoscape({
  container: document.getElementById('cy'), // container to render in
  elements: [],
  style: [{
    selector: 'node',
    style: {
      'shape': 'rectangle',
      'width': '66',
      'height': '54',
      'content': 'data(name)',
      'text-valign': 'center',
      'background-color': '#FFFF99',
      'border-color': 'black',
      'border-width': '1',
      'text-wrap': 'wrap',
      'background-color': '#666',
      'label': 'data(id)',
      'z-index': 1,
      'min-zoomed-font-size': 9,
    }
  },{
    selector: ':parent',
    style: {
      'text-valign': 'top',
      'z-index': 0,
    }
  },{
    selector: 'edge',
    style: {
      'width': 3,
      'line-color': '#ccc',
      'target-arrow-color': '#ccc',
      'target-arrow-shape': 'triangle',
      'curve-style': 'straight-triangle'
    }
  },{
    selector: '.hidden',
    style: { display:'none', 'text-opacity': 0 }
  },{
    selector: '.faded',
    style: { 'opacity': 0.25, 'text-opacity': 0 }
  }],
  //layout: { name: 'grid', fit: true, padding: 11, rows: 3 },
  layout: { name: 'fcose', fit:true },
  ready: function(){
    let cy = this;
    cy.elements().unselectify();
    cy.selectedNode = null;
    cy.on('tap', 'node:childless', function(e){
      var node = e.target;
      if(cy.selectedNode !== null && cy.selectedNode !== node) {
        cy.add({group:"edges",data:{target:node.id(),source:cy.selectedNode.id()},});
        if(relType=='w')cy.add({group:"edges",data:{target:node.id(),source:cy.selectedNode.id()},});
        else cy.add({group:"edges",data:{source:node.id(),target:cy.selectedNode.id()},});
        pageRank();
        larr.shift()?.run()
        cy.elements().removeClass('faded');
        cy.selectedNode = null;
      } else {
        cy.elements().addClass('faded');
        node.removeClass('faded');
        node.select();
        cy.selectedNode = node;
      }
    });
    cy.on('tap', function(e){
      if( e.cyTarget === cy ){
        cy.elements().removeClass('faded');
        cy.selectedNode = null;
      }
    });
    //cy.on('add','node', ()=>genLayout(1))
    //cy.on('move','node', ()=>genLayout(1))
    cy.on('layoutstop',()=>{
      //console.log(larr.length)
      larr.shift()?.run()
    })
  }
});
var larr=[];
var genLayout=t=>{
  console.log('gen Layout')
  //larr.push(
    cy.layout({
      name:'fcose',
      tilingPaddingVertical: 3,tilingPaddingHorizontal:3,
      nodeReplusion: _=>4444,
      idealEdgeLength: _=>27,
      packComponents:true,
      animationDuration: 243*t,
      fit:true,
      randomize:false,
    }).run()
  //)
  }
document.getElementById('result').onclick = () => {
  relType = relType=='w'?'d':'w'
  document.getElementById('result').innerText = relType=='w'?'Wins':'Draws'
}
function addTeam(){
  cy.add({
    group: "nodes",
    data: { id: '' + nextID, name: 'Team '+nextID },
    position: {
      x: 100 + nextID % 4 * 150,
      y: 100 + 120* Math.floor(nextID / 4),
    }
  });
  nextID++;
  pageRank();
}document.getElementById('addTeam').onclick=addTeam
var mode = 1;
document.getElementById('community').onclick=()=>{
  mode^=1;
  document.getElementById('community').innerText = `Louvain ${mode?'':'Un'}Directed Community`
  pageRank();
}
function normalizedPageRank(opts){
  var pr = cy.elements().pageRank(opts);
  var borders={min:Number.MAX_VALUE,max:Number.MIN_VALUE};
  cy.nodes().forEach(n=>Object.keys(borders).forEach(f=>borders[f]=Math[f](borders[f],pr.rank(n))))
  const arr = Array(cy.nodes().length).fill(0);
  cy.nodes().forEach(a=>arr[cy.nodes().indexOf(a)]=(pr.rank(a)-borders.min)/(borders.max-borders.min))
  return { rank: function( node ){
    node = cy.collection(node)[0];
    return arr[ cy.nodes().indexOf(node) ];
  }};
}
const roundTo3=x=>Math.round(x*1e3)/1e3
function pageRank() {
  //console.clear();
  cy.nodes().filter(':childless').forEach(n=>n.move({parent:null}))
  cy.nodes().filter('[^name]').remove()
  // let pr = normalizedPageRank({'dampingfactor': 0.85});
  let er = cy.elements().eigenRank();
  //var or = cy.elements().eigenRankOrig();
  window.pr = cy.elements();
  // pr: ${roundTo3(pr.rank(ele))}
  cy.nodes().forEach( ele => ele.style({'content': `${ele.data('name')}
er: ${roundTo3(er.rank(ele))}
` }));
  cy.nodes().flashClass('nolabel',1);
  for(let res=1,count=0,level=1;Boolean(res);level++,count++){
    console.log(JSON.stringify({level}))
    res = cy.elements().louvain({mode,level})
    if(level>27||count>27)break;
  }
  cy.nodes().filter(':orphan[^name]').forEach(n=>{
    let des = n.descendants().filter(':childless')
    let er = des.edgesWith(des).union(des).eigenRank()
    des.forEach(e=>e.style({'content':`${e.style().content}\nler: ${roundTo3(er.rank(e))}`}))
  })
  genLayout(3)
}
function deleteSelected() {
  var selection = cy.$(':selected');
  var edgesToRemove = selection.connectedEdges();
  edgesToRemove.remove();
  selection.remove();
  cy.selectedNode = null;
  cy.elements().removeClass('faded');
  pageRank();
}
document.getElementById('delete').onclick=deleteSelected;
document.getElementById('Layout').onclick=()=>genLayout(1);
/*
for(let i=0;i<12;i++){
  cy.add({
    group: "nodes",
    data: { id: '' + nextID, name: 'Team '+nextID },
    position: {
      x: 100 + nextID % 4 * 150,
      y: 100 + 120* Math.floor(nextID / 4),
    }
  });
  nextID++;
  if(i==11)pageRank();
}
const battles = require('./bd.json')
for(let s in battles)for(let t in battles[s]){
  cy.$id(s).length||cy.add({ group:'nodes', data: {id: s, name: 'Team '+nextID++ }, })
  cy.$id(t).length||cy.add({ group:'nodes', data: {id: t, name: 'Team '+nextID++ }, })
  cy.add({group:"edges",data:{target:t,source:s},});
  if(battles[s][t]>1) cy.add({group:"edges",data:{target:t,source:s},});
}
*/
cy.add(require('./bd.json'))
// require('./bd.json').forEach(x=>(console.log(x),cy.add(x)))
pageRank()
